import L from "leaflet";
import "leaflet/dist/leaflet.css";

function createMap(mapSelector, options = {}) {
    const mapEl =
        typeof mapSelector === "string"
            ? document.querySelector(mapSelector)
            : mapSelector;

    if (!mapEl) return null;

    const map = L.map(mapEl, {
        minZoom: options.minZoom ?? 10,
        maxZoom: options.maxZoom ?? 19,
        scrollWheelZoom: options.scrollWheelZoom ?? false
    }).setView(options.center ?? [45.5997097, -122.739378], options.zoom ?? 12);

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: "&copy; OpenStreetMap contributors"
    }).addTo(map);

    if (options.tileUrl) {
        L.tileLayer(options.tileUrl, {
            attribution: options.attribution ?? '© <a href="http://www.portofportland.com">Port of Portland</a>',
            tms: options.tms ?? false,
            opacity: options.opacity ?? 1
        }).addTo(map);
    }

    return map;
}

function initPortMap(mapSelector, config = {}) {
    const {
        center = [45.5997097, -122.739378],
        zoom = 12,
        minZoom = 10,
        maxZoom = 19,
        scrollWheelZoom = false,
        tileUrl = null,
    } = config;

    const map = createMap(mapSelector, {
        center,
        zoom,
        minZoom,
        maxZoom,
        scrollWheelZoom,
        tileUrl
    });

    if (!map) return null;

    return map;
}

window.PortJS = window.PortJS || {};
window.PortJS.initPortMap = initPortMap;

export { initPortMap };
